export const DS_URL_FIELD_CLASSES = {
  Root: "ds-url-field",
} as const;
